var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('Header'),_c('bg'),_c('top-report'),_c('search-content'),_c('old-data'),_c('video-swiper'),_c('client'),_c('Footer'),_c('right-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }